import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { Window } from '../../reducers/window';
import { md } from '../../utils/breakpoints';
import { mapStateToProps } from '../../utils/mapper';
import { colors } from '../../utils/styles';
import MenuContainer from './menu_container';

import Close from '../../modules/svgs/close';
import Hamburger from '../../modules/svgs/hamburger_menu';

import { openUrl } from '../../modules/links';

interface MenuProps {
  showMenu?: boolean,
  window: Window & { multiplier: number };
  menuItems: any;
  home: () => void;
  test?: boolean;
  dispatch: (action?: any) => any;
};

const styles = (multiplier) => ({
  button: RX.Styles.createButtonStyle({
    alignItems: 'center',
    backgroundColor: colors.primary,
    height: 60 * multiplier,
    marginRight: -12 * multiplier,
    marginTop: -8 ,
    width: 60 * multiplier,
  }),
  header: RX.Styles.createViewStyle({
    backgroundColor: colors.white,
    flexDirection: 'row',
    height: 60 * multiplier,
    justifyContent: 'space-between',
    left: 0,
    padding: 8,
    top: 0,
  }),
  iosHeader: RX.Styles.createViewStyle({
    height: 60 * multiplier,
    paddingTop: 5 * multiplier,
  }),
  logo: RX.Styles.createImageStyle({
    height: 45 * multiplier,
    width: 267 * multiplier,
  }),
});

export class Menu extends RX.Component<MenuProps, RX.CommonProps & { showMenu: boolean }> {

  constructor(props: MenuProps) {
    super(props);
    this.state = { showMenu: true };

    this.menuToggle = this.menuToggle.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  public componentDidMount() {
    this.props.dispatch({ type: 'TOGGLE_MENU', toggle: this.closeMenu })
  }

  public render() {
    const { menuItems, window: { width, multiplier, menuHeight = 0, landscape }, test } = this.props;
    const ios = RX.Platform.getType() === 'ios';
    return (
      <RX.View
        style={[
          { borderWidth: 0, borderBottomWidth: 1, borderColor: colors.black },
          {
            backgroundColor: colors.white,
            borderColor: colors.primary,
            borderTopWidth: 4 * multiplier,
            width,
          },
          width >= md
            ? { minHeight: 100  * multiplier, alignItems: 'center' }
            : { height: !this.state.showMenu ? menuHeight + (ios && !landscape ? 60 * multiplier : 60  * multiplier) : ios && !landscape ? 60 * multiplier : 60  * multiplier} //tslint:disable-line
        ]}
      >
        <RX.View
          style={[
            styles(multiplier).header,
            { width, maxWidth: 1200 },
            ios && !landscape ? styles(multiplier).iosHeader : {},
            !this.state.showMenu ? { backgroundColor: colors.primary } : {},
            landscape ? { paddingLeft: 24 } : 0
          ]}
        >
        <RX.Button
          onPress={() => openUrl('/', '_self')}
        >
          {RX.Platform.getType() !== 'web' ? <RX.Image
            style={styles(multiplier).logo}
            source={RX.Platform.getType() !== 'web' && !this.state.showMenu ?
              require('../../assets/PM_LGHealth_RGB_535x90_WebsiteVersionLogo_Rev.png')
                : require('../../assets/PM_LGHealth_RGB_535x90_WebsiteVersionLogo.png')}
            resizeMode='contain' />
            : <img
              style={{height: 45 * multiplier, width: 267 * multiplier }}
              src={!this.state.showMenu ?
                require('../../assets/PM_LGHealth_RGB_535x90_WebsiteVersionLogo_Rev.png')
              : require('../../assets/PM_LGHealth_RGB_535x90_WebsiteVersionLogo.png')} />}
        </RX.Button>
          {width < md &&
            <RX.Button
              testId='hamburger-menu'
              onPress={this.menuToggle}
              style={[!this.state.showMenu ? styles(multiplier).button : {}, landscape ? { paddingRight: 8 } : {}]}
            >
              {!test && (this.state.showMenu
                ? <Hamburger style={{
                  height: 35 * multiplier,
                  width: 35 * multiplier
                }}/>
              : <Close style={{
                height: 35 * multiplier,
                width: 35 * multiplier
              }}/>)}
            </RX.Button>}
        </RX.View>

        {(!this.state.showMenu || width >= md) && !test
          && <MenuContainer menuSections={menuItems} catcherPress={this.menuToggle}/>}
      </RX.View>
    );
  }

  private menuToggle() {
    this.setState({ showMenu: !this.state.showMenu });
  }

  private closeMenu() {
    this.setState({ showMenu: true });
  }
}

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/menu/index.tsx